import {
  toPluginChemical,
  toPluginDrug,
  toPluginModelElement,
} from '@/services/pluginsManager/adapters/toPluginModelElement';
import { PluginsEventBus } from '@/services/pluginsManager/pluginsEventBus';
import type { RootState } from '../store';

export const dispatchPluginsEvents = (searchQueries: string[], state: RootState): void => {
  const searchModelElements = state.modelElements.search.data;
  const modelElementsResults = searchQueries.map(searchQuery => {
    const searchElement = searchModelElements.find(
      element => element.searchQueryElement === searchQuery,
    );
    return (searchElement?.data || []).map(result => {
      return {
        perfect: result.perfect,
        bioEntity: toPluginModelElement(result.modelElement),
      };
    });
  });

  const drugs = state.drugs.data;
  const drugsResults = searchQueries.map(searchQuery =>
    (drugs.find(drug => drug.searchQueryElement === searchQuery)?.data || []).map(toPluginDrug),
  );

  const chemicals = state.chemicals.data;
  const chemicalsResults = searchQueries.map(searchQuery =>
    (chemicals.find(chemical => chemical.searchQueryElement === searchQuery)?.data || []).map(
      toPluginChemical,
    ),
  );

  PluginsEventBus.dispatchEvent('onSearch', {
    type: 'bioEntity',
    searchValues: searchQueries,
    results: modelElementsResults,
  });
  PluginsEventBus.dispatchEvent('onSearch', {
    type: 'drugs',
    searchValues: searchQueries,
    results: drugsResults,
  });
  PluginsEventBus.dispatchEvent('onSearch', {
    type: 'chemicals',
    searchValues: searchQueries,
    results: chemicalsResults,
  });
};
